import { Spinner } from "@fluentui/react-components";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import PageEnum from "../../enum/PageEnum";
import { useApiCall } from "../../hooks/useApiCall";
import {
  IPassengerResourceData,
  IPassengerSummaryApiData,
} from "../../models/pax/IPaxTypes";
import { useAppDispatch } from "../../store/StoreHooks";
import { screenNameActions } from "../../store/screen/ScreenNameSlice";
import {
  AIRPORT_CODE_PARAMETER,
  EMPTY_STATE_MESSAGE,
} from "../../utils/common/Constants";
import { PassengerHelper } from "../../utils/pax/PassengerHelper";
import { NoDataCard } from "../common/no-data-card/NoDataCard";
import { PassengerKPISection } from "./PassengerKPISection";
export interface IPassengerKPIProps {
  airport: string;
}
export const PassengerKPI: React.FunctionComponent<IPassengerKPIProps> = ({
  airport,
}) => {
  const [resourceData, setResourceData] = useState<
    IPassengerResourceData | undefined
  >(undefined);
  const { globalFilterDate } = React.useContext(LayoutContext);
  const dateFormat = "yyyy-MM-dd'T'HH:mm:ss";
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      screenNameActions.setScreenName(PageEnum.BreadcrumbEnum.Passenger)
    );
  }, [dispatch]);
  const getPassengerSummaryUrl = `${process.env.REACT_APP_API_PAX_SUMMARY?.replace(
    AIRPORT_CODE_PARAMETER,
    airport
  )
    .replace("{startDateTime}", format(globalFilterDate.startDate, dateFormat))
    .replace("{endDateTime}", format(globalFilterDate.endDate, dateFormat))}`;

  const {
    data: passengerSummaryDataResponse,
    error,
    isLoading,
  } = useApiCall<IPassengerSummaryApiData>({
    url: getPassengerSummaryUrl,
    dependencies: [airport],
  });
  useEffect(() => {
    if (passengerSummaryDataResponse) {
      const paxResponse = Object.keys(passengerSummaryDataResponse).map(
        (key: string) => {
          const obj = passengerSummaryDataResponse[key];
          return { type: key, ...obj };
        }
      );
      const passengerSummaryData = paxResponse.filter(
        (element) => element.type !== "total"
      );
      const transformed = passengerSummaryData
        .map((item) => {
          const remote =
            item?.breakdown?.find((b: any) => b.type === "Remote")?.kpiValue ||
            0;
          const contact =
            item?.breakdown?.find((b: any) => b.type === "Contact")?.kpiValue ||
            0;
          return {
            type: item.type.toLowerCase(),
            total: item.kpiValue,
            contact: contact,
            remote: remote,
          };
          //   }
        })
        .filter((item) => item.type !== "overall");

      setResourceData({
        total: PassengerHelper.getChartData(transformed, "total", true),
        arrival: PassengerHelper.getChartData(transformed, "arrivals", false),
        departure: PassengerHelper.getChartData(
          transformed,
          "departures",
          false
        ),
      });
    }
  }, [passengerSummaryDataResponse]);

  return (
    <>
      <div className="ms-Grid" dir="ltr" data-testid="passenger-kpi">
        {error && <NoDataCard message={EMPTY_STATE_MESSAGE.Passenger} />}
        {isLoading && (
          <Spinner
            labelPosition="below"
            label="Loading..."
            style={{ height: "25vh" }}
          />
        )}
        {!error && !isLoading && (
          <PassengerKPISection
            resourceData={resourceData}
            emptyStateMessage={EMPTY_STATE_MESSAGE.Passenger}
          />
        )}
      </div>
    </>
  );
};
